import http from '@utils/http';

export const getSalaryDistribution = (params = {}) =>
    http.get('/hr/salary/distribution', { params }).then((res) => res.data?.data ?? res.data);

export const getSalaryConfig = () =>
    http.get('/hr/salary/config').then((res) => res.data?.data ?? res.data);

export const upsertSalaryConfig = (body) =>
    http.post('/hr/salary/config', body).then((res) => res.data?.data ?? res.data);

export const updateMonthlySalary = (userId, month, body) =>
    http.put(`/hr/salary/${userId}/${month}`, body).then((res) => res.data?.data ?? res.data);

export const updateEmployeeSalary = (userId, body) =>
    http.put(`/hr/employees/${userId}/salary`, body).then((res) => res.data?.data ?? res.data);

export const bulkUpdateSalaryStatus = (body) =>
    http.post('/hr/salary/bulk-status', body).then((res) => res.data?.data ?? res.data);
